import { render, staticRenderFns } from "./editpatient.vue?vue&type=template&id=08380640&scoped=true"
import script from "./editpatient.vue?vue&type=script&lang=js"
export * from "./editpatient.vue?vue&type=script&lang=js"
import style0 from "./editpatient.vue?vue&type=style&index=0&id=08380640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08380640",
  null
  
)

export default component.exports